var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14 3.236L4.207 4.315A3 3 0 002 7.208v10.514a2.5 2.5 0 003.161 2.41l2.98-.816a3 3 0 011.708.036l4.302 1.376a3 3 0 001.708.036l3.935-1.079A3 3 0 0022 16.792V6.278a2.5 2.5 0 00-3.161-2.41l-2.98.816a3 3 0 01-1.708-.036L9.85 3.272a3 3 0 00-1.708-.036z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.79v16.08a3.001 3.001 0 01-.849-.142L9.85 19.35A3.001 3.001 0 009 19.209V3.129a3 3 0 01.849.142l4.302 1.377A3 3 0 0015 4.79z",
    fill: "#9F9F9F"
  })));
}

export default SvgMap;